import { Product } from "./product";
import { SelectedProduct } from "./selected-product";
import { ShippingDetails, User } from "./user";

export interface Order {
    id: string,
    orderId: string,
    userId: string,
    trackingNumber?: string,
    products: SelectedProduct[],
    subTotal: number,
    shippingFee: number,
    serviceCharge: number,
    discount: number,
    total: number,
    user: User,
    status: OrderStatus,
    type: OrderType,
    shippingDetails: ShippingDetails,
    paymentDetails?: PaymentDetails,
    termsAndConditions:boolean
    createdAt: string
    updatedAt: string
}

export enum OrderStatus {
    ALL = 'All',
    PENDING = 'Pending',
    CONFIRMED = 'Confirmed',
    PACKING = 'Packing',
    SHIPPED = 'Shipped',
    DELIVERED = 'Delivered',
    CANCELLED = 'Cancelled'
}

export enum OrderType {
    BANK='Bank',
    KOKO='Koko',
    PAYHERE='PayHere'
}

export interface PaymentDetails {
    method: string;
    transactionId: string;
    amount: number;
    status: string;
}